import { t } from "@ebay/i18n-ebay";
import { getPropsForViewTracking, getModuleMetaTracking, getPropsForEmptyMapViewTracking } from "../../utils/tracking";
$ const { isLoadMoreEnabled, layout, listingsView, isMobile, isRecommendationsView, model } = input || {};
$ const shouldShowLeftRail = listingsView === "left-rail" && !isMobile;
$ const shouldShowCarousel = state.clusterPointsOfInterest.length > 0 && state.selectedItems.length > 0 && !shouldShowLeftRail;
$ const singleItemSelected = state.selectedItems.length === 1;
$ const prevSingleItemSelected = state.prevSelectedItems.length === 1;
$ const isLeftRailLoading = input.waitingForService || state.isLoading;
$ const showNoResultsBanner = shouldShowLeftRail && !state.isLoadingMoreItems && state.leftRailItems?.length < state.pointsOfInterest?.length;

<div
  data-testid="map-container"
  class=[
    "map-wrapper",
    `map-layout-${layout}`,
    `map-listings-view-${listingsView}`,
    state.isLeftRailItemHover && "map-listings-view-left-rail__hovering",
  ]
>
  <if(state.isEmptyMapTrackerVisible)>
    <div class="clipped" id="map-tracker" ...getPropsForEmptyMapViewTracking(getModuleMetaTracking(model))>
      <a href="#">
        Empty map tracker
      </a>
    </div>
  </if>
  <if(shouldShowLeftRail)>
    <items-left-rail
      pointsOfInterest=state.pointsOfInterest
      leftRailItems=state.leftRailItems
      isLoading=isLeftRailLoading
      highlightedItem=state.highlightedItem
      prevHighlightedItem=state.prevHighlightedItem
      showErrorMessage=state.showErrorMessage
      isLeftRailItemHover=state.isLeftRailItemHover
      prevSelectedItems=state.prevSelectedItems
      selectedItems=state.selectedItems
      cta=state.resetMapviewButton
      isPreviewCardEnabled=state.isPreviewCardEnabled
      on-cta-click("onShowAll")
      on-item-hover("onItemHover")
      on-unhover-item("onUnhoverItem")
    />
  </if>
  <if(showNoResultsBanner && state.mapMessage)>
    <map-message mapMessage=state.mapMessage on-cta-click("onShowAll")/>
  </if>

  <div data-testid="map" id="map" class="map" key="map" no-update-body ...getPropsForViewTracking(getModuleMetaTracking(model))/>
  <map-help help=state.help/>

  <if(isMobile)>
    <if(state.survey)>
      <map-survey class="map-user-feedback-icon-button" type="icon-button" model=state.survey/>
    </if>
  </if>
  <else>
    <map-zoom on-zoom-in("handleZoomIn") on-zoom-out("handleZoomOut")/>
    <if(state.surveyButton && shouldShowLeftRail)>
      <map-survey class="map-user-feedback-button" type="button" model=state.surveyButton/>
    </if>
  </else>

  <if(singleItemSelected && !shouldShowLeftRail)>
    <map-item itemCard=(state.pointsOfInterest[state.selectedItems[0]].itemCard) key=String(state.highlightedItem)/>
  </if>
  <if(prevSingleItemSelected && state.pointsOfInterest[state.prevSelectedItems?.[0]])>
    <map-item itemCard=(state.pointsOfInterest[state.prevSelectedItems[0]].itemCard) isPrev key=String(state.prevHighlightedItem)/>
  </if>
  <if(shouldShowCarousel)>
    <items-carousel pointsOfInterest=state.clusterPointsOfInterest/>
  </if>
  <if(isLoadMoreEnabled && isRecommendationsView)>
    <if(state.isLoadMoreVisible && !state.isLoadingMoreItems)>
      <load-more-button on-load-more("onLoadMoreClickHandler") entryPageId=input.entryPageId isMoreResultsBannerVisible=showNoResultsBanner>
        ${t("mapview/map", "loadMoreItems")}
      </load-more-button>
    </if>
    <if(state.showErrorMessage && !shouldShowLeftRail)>
      <ebay-page-notice class="map-notice" icon="none" status="education">
        <p data-testid="map-notice-text">
          ${t("mapview/map", "loadMoreErrorMessage")}
        </p>
      </ebay-page-notice>
    </if>
  </if>
  <if(input.waitingForService)>
    <div class="map-loading" data-testid="map-loading">
      <ebay-progress-spinner size="large"/>
    </div>
  </if>
</div>
